import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CustomInput, Form, FormGroup, Label } from 'reactstrap';
import './styles.scss';

export class FilterContactsCard extends Component {
  // static propTypes = {
  //   type: PropTypes.string.isRequired
  // };

  render() {
    return (
      <Card className="filter-card">
        <CardBody>
          <div className="filter-card_title">Контакты</div>
          <Form>
            <FormGroup>
              <Label for="exampleCustomSelect" hidden>Custom Select</Label>
              <CustomInput type="select" id="exampleCustomSelect" name="customSelect">
                <option value="">Поставщик</option>
                <option>Value 1</option>
                <option>Value 2</option>
                <option>Value 3</option>
                <option>Value 4</option>
                <option>Value 5</option>
              </CustomInput>
            </FormGroup>

            <FormGroup>
              <Label for="exampleCustomSelect" hidden>Custom Select</Label>
              <CustomInput type="select" id="exampleCustomSelect" name="customSelect">
                <option value="">Получатель</option>
                <option>Value 1</option>
                <option>Value 2</option>
                <option>Value 3</option>
                <option>Value 4</option>
                <option>Value 5</option>
              </CustomInput>
            </FormGroup>
          </Form>
        </CardBody>
      </Card>
    );
  }
}

export class FilterPaymentCard extends Component {
  render() {
    return (
      <Card className="filter-card">
        <CardBody>
          <div className="filter-card_title">Оплата</div>
          <Form>
            <FormGroup>
              <Label for="exampleCustomSelect" hidden>Custom Select</Label>
              <CustomInput type="select" id="exampleCustomSelect" name="customSelect">
                <option value="">Тип оплаты</option>
                <option>Value 1</option>
                <option>Value 2</option>
                <option>Value 3</option>
                <option>Value 4</option>
                <option>Value 5</option>
              </CustomInput>
            </FormGroup>

            <FormGroup>
              <Label for="exampleCustomSelect" hidden>Custom Select</Label>
              <CustomInput type="select" id="exampleCustomSelect" name="customSelect">
                <option value="">Статус оплаты</option>
                <option>Value 1</option>
                <option>Value 2</option>
                <option>Value 3</option>
                <option>Value 4</option>
                <option>Value 5</option>
              </CustomInput>
            </FormGroup>
          </Form>
        </CardBody>
      </Card>
    );
  }
}

export class FilterStatusCard extends Component {
  render() {
    return (
      <Card className="filter-card">
        <CardBody>
          <div className="filter-card_title">Статус</div>
          <Form>
            <FormGroup>
              <Label for="exampleCustomSelect" hidden>Custom Select</Label>
              <CustomInput type="select" id="exampleCustomSelect" name="customSelect">
                <option value="">Статус заказа</option>
                <option>Value 1</option>
                <option>Value 2</option>
                <option>Value 3</option>
                <option>Value 4</option>
                <option>Value 5</option>
              </CustomInput>
            </FormGroup>
          </Form>
        </CardBody>
      </Card>
    );
  }
}
export class FilterInvoiceCard extends Component {
  render() {
    return (
      <Card className="filter-card">
        <CardBody>
          <div className="filter-card_title">Выплата</div>
          <Form>
            <FormGroup>
              <Label for="exampleCheckbox" hidden>Radios</Label>
              <div>
                <CustomInput type="radio" id="exampleCustomRadio" name="customRadio" label="Все" />
                <CustomInput type="radio" id="exampleCustomRadio2" name="customRadio" label="Выплачено" />
                <CustomInput type="radio" id="exampleCustomRadio3" name="customRadio" label="Не выплачено" />
              </div>
            </FormGroup>
          </Form>
        </CardBody>
      </Card>
    );
  }
}

export class FilterDateCard extends Component {
  render() {
    return (
      <Card className="filter-card">
        <CardBody>
          <div className="filter-card_title">Дата</div>
          <Form>
            <FormGroup>

            </FormGroup>
          </Form>
        </CardBody>
      </Card>
    );
  }
}

